import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery';
import ProgressBar from './ProgressBar';

import CreateEditBid from './CreateEditBid'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchBid,
    fetchBidError,
    createBid,
    updateBid,
    errorBid,
    sortBid,
    fetchBidsList,
    setBidsFilters,
    fetchBidHistory,
    errorBidHistory,
    fetchBidUsers,
    errorBidUsers,
    export_excel_bids
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'
import FilterList from '../../Shared/FilterList/FilterList'

import './Bids.css'

var Spinner = require('react-spinkit');

let chkReturn = 0
let clearFilter = false

const HIST_PAGE_SZE = 25

class Bids extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bid: {
                accountId: 0,
                appliancePackageQuoted: false,
                bidAmount: null,
                bidNotes: [],
                bidStatusId: null,
                cabinetManufacturerId: null,
                companyName: "",
                contactName: "",
                contactPhone: null,
                estimatedStartDate: "",
                estimatedStartDateDisplay: "",
                installQuoted: false,
                kitchenTopsId: null,
                lastUpdatedAt: "",
                numberOfUnits: "0",
                projectCity: "",
                projectName: "",
                projectStateId: null,
                salesPerson: "",
                submissionDate: "",
                submissionDateDisplay: "",
                unitTypeId: null,
                vanityTopsId: null,
                bidDueDate: "",
                bidSubmittedDate: "",
                margin: null,
                quotedDoorStyle: "",
                cabinetDoorFinish: "",
                cabinetSpecified: "",
                projectOwner: ""
            },
            historyPage: 1,
            historyDate: '',
            historyUser: '',
            viewBid: false,
            editBidMode: false,
            clearFilter: false,
            activeStatusFilters: ['Active'],
            activeBidStatusFilters: [],
            progress: this.props.bids.percent_complete,
            percentage: 0,
            value: -1,
            complete: false
        };

        this.fetchBidErrorClear = this.fetchBidErrorClear.bind(this);
        this.errorBidClear = this.errorBidClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.bidView = this.bidView.bind(this);

        this.bidEdit = this.bidEdit.bind(this);
        this.bidEditVerify = this.bidEditVerify.bind(this);

        this.bidCreate = this.bidCreate.bind(this);
        this.updateBid = this.updateBid.bind(this);
        this.bidExport = this.bidExport.bind(this);

        this.cancelBid = this.cancelBid.bind(this);
        this.closeBid = this.closeBid.bind(this);

        this.selectPanel = this.selectPanel.bind(this);

        this.afterOpen = this.afterOpen.bind(this);
        this.bidCheck = this.bidCheck.bind(this);

        this.sortColumn = this.sortColumn.bind(this);

        this.newDateSearch = this.newDateSearch.bind(this);
        this.newUserSearch = this.newUserSearch.bind(this);

        this.loadMore = this.loadMore.bind(this);

        this.processStatusFilter = this.processStatusFilter.bind(this);
        this.processBidStatusFilter = this.processBidStatusFilter.bind(this);
    }

    componentDidMount() {
        if (window.location.pathname.toLowerCase() !== '/prod-mgmt/bidslist') {
            let pathParts = window.location.pathname.split('/')
            let id = pathParts[pathParts.length - 1]

            this.setState({ viewBid: true, viewBidExtra: true })

            fetchBid.bind(this)(id);
            fetchBidHistory.bind(this)({ bidId: id, pageIndex: 1, pageSize: HIST_PAGE_SZE });
            fetchBidUsers.bind(this)({ bidId: id })

            chkReturn = setInterval(this.bidEditVerify, 100);
        }
    }

    selectPanel(e) {
        $('div.panelFrame').css('display', 'none')
        $('li.bidview').removeClass("selected")

        e.currentTarget.className = "bidview selected"
        $('div#' + e.currentTarget.attributes["panel"].value).css('display', 'block')

        if (this.state.viewBid) {
            if (e.currentTarget.attributes["panel"].value == 'History') {
                $('button.bid').css('display', 'none')
            }
            else {
                $('button.bid').css('display', 'inline-block')
            }
        }
    }

    newDateSearch() {
        if (chkReturn) return;
        chkReturn = 1;

        let histDate = $('#history-date').val()

        if (histDate != this.state.historyDate) {
            this.setState(
                {
                    historyPage: 1,
                    historyDate: histDate
                })

            let userInfo = histDate ?
                    { bidId: this.props.bid.bid.id, bidDate: histDate }
                :
                    { bidId: this.props.bid.bid.id }

            let histInfo = histDate ?
                    { bidId: this.props.bid.bid.id, bidDate: histDate, user: this.state.historyUser, pageIndex: 1, pageSize: HIST_PAGE_SZE }
                :
                    { bidId: this.props.bid.bid.id, user: this.state.historyUser, pageIndex: 1, pageSize: HIST_PAGE_SZE }

            fetchBidUsers.bind(this)(userInfo)
            fetchBidHistory.bind(this)(histInfo);

            chkReturn = setInterval(this.bidEditVerify, 100);
        }
        else
            chkReturn = 0
    }

    newUserSearch(histUser) {
        if (chkReturn) return;
        chkReturn = 1;

        if (histUser != this.state.historyUser) {
            this.setState(
                {
                    historyPage: 1,
                    historyUser: histUser
                })

            let histInfo = this.state.historyDate ?
                    { bidId: this.props.bid.bid.id, bidDate: this.state.historyDate, user: histUser, pageIndex: 1, pageSize: HIST_PAGE_SZE }
                :
                    { bidId: this.props.bid.bid.id, user: histUser, pageIndex: 1, pageSize: HIST_PAGE_SZE }

            fetchBidHistory.bind(this)(histInfo);

            chkReturn = setInterval(this.bidEditVerify, 100);
        }
        else
            chkReturn = 0
    }

    loadMore(e) {
        if (chkReturn) return;
        chkReturn = 1;

        let histPage = this.state.historyPage
        let histDate = this.state.historyDate
        let histUser = this.state.historyUser

        if (this.props.bid.history.bidChangeHistoryRecords.length < this.props.bid.history.totalRecords) {
            histPage++
            this.setState({ historyPage: histPage })
        }
        else {
            chkReturn = 0
            return
        }

        let histInfo = histDate ?
                { bidId: this.props.bid.bid.id, bidDate: histDate, user: histUser, pageIndex: histPage, pageSize: HIST_PAGE_SZE }
            :
                { bidId: this.props.bid.bid.id, user: histUser, pageIndex: histPage, pageSize: HIST_PAGE_SZE }

        fetchBidHistory.bind(this)(histInfo);

        chkReturn = setInterval(this.bidEditVerify, 100);
    }

    afterOpen() {
        $('div#Details').css('display', 'block')
        $('li[panel="Details"]').addClass('selected')

        if (this.state.editBid) {
            $('input#submissionDate').attr('disabled', 'disabled')
        }

        if (this.state.viewBid) {
            $('div.detailsPanel input, div.detailsPanel select').each(function () {
                $(this).attr('disabled', 'disabled')
            })

            $('button.bid').text('Add Note')
        }
        else this.bidCheck()
    }
    bidCheck() {
        let bid_good = true
        const regex = /^[0-9]+$/

        const requiredElements = ["#salesPerson", "#contactName", "#companyName", "#projectName",
            "#projectCity", "#projectStateId", "#numberOfUnits", "#unitTypeId", "#bidAmount", "#estimatedStartDate",
            "#bidDueDate", "#bidSubmittedDate", "#projectOwner", "#margin", "#quotedDoorStyle", "#cabinetDoorFinish", "#cabinetSpecified"]
        $(requiredElements.join(",")).each(function () {
            let val = $(this).val()
            const datatype = this.dataset.type;
            if (val == '' || val == 0 || val == 'Select') {
                bid_good = false
                $(this).addClass('input-error')
            } else if (datatype === "number" && !regex.test(val)) {
                bid_good = false
                $(this).addClass('input-error')
            }
            else {
                $(this).removeClass('input-error')
            }
         })

        if (bid_good) {
            $('button.btn-primary').removeAttr('disabled')
        }
        else {
            $('button.btn-primary').attr('disabled', 'disabled')
        }
    }

    sortColumn(e) {
        let sortOrder
        let sortElement = e.target.children.length === 0 ? e.target.parentElement : e.target
        let sortBy = sortElement.id
        let sort = sortElement.children[0].className.split(' ')[1]

        if (sort === "fa-sort") {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }
        else if (sort === "fa-sort-asc") {
            sortOrder = "Descending"
            sortElement.children[0].className = "fa fa-sort-desc fa-xs"
        }
        else {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }

        $('th').each(function () {
            if ($(this).attr('id') !== sortElement.id) {
                $(this).removeClass("sort")
                $($(this).children()[0]).removeClass("fa-sort-asc")
                $($(this).children()[0]).removeClass("fa-sort-desc")
                $($(this).children()[0]).addClass("fa-sort")
            }
        })

        sortElement.className = "sort"

        sortBid.bind(this)(sortBy, sortOrder);
    }

    fetchBidErrorClear() {
        this.props.dispatch(fetchBidError);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    errorBidClear(e) {
        this.props.dispatch(errorBid);

        if (this.props.bid.error === "409") {
            let id = e.target.attributes.bid.value;

            fetchBid.bind(this)(id);
        }
    }

    bidView(e) {
        this.setState({ viewBid: true })
        this.bidEdit(e)
    }

    bidEdit(e) {

        if (chkReturn) return;
        chkReturn = 1;

        let id = parseInt(e.target.attributes.bid.value);

        this.setState({
            bid: {
                accountId: 0,
                appliancePackageQuoted: false,
                bidAmount: null,
                bidNotes: [],
                bidStatusId: null,
                cabinetManufacturerId: null,
                companyName: "",
                contactName: "",
                contactPhone: null,
                estimatedStartDate: "",
                estimatedStartDateDisplay: "",
                installQuoted: false,
                kitchenTopsId: null,
                lastUpdatedAt: "",
                numberOfUnits: "0",
                projectCity: "",
                projectName: "",
                projectStateId: null,
                salesPerson: "",
                submissionDate: "",
                submissionDateDisplay: "",
                unitTypeId: null,
                vanityTopsId: null,
                bidDueDate: "",
                bidSubmittedDate: "",
                margin: null,
                quotedDoorStyle: "",
                cabinetDoorFinish: "",
                cabinetSpecified: "",
                projectOwner: ""
            }
        });

        fetchBid.bind(this)(id);
        fetchBidHistory.bind(this)({ bidId: id, pageIndex: 1, pageSize: HIST_PAGE_SZE });
        fetchBidUsers.bind(this)({ bidId: id })

        chkReturn = setInterval(this.bidEditVerify, 100);
    }
    bidEditVerify() {
        if (this.props.bid.updated || this.props.bid.error) {
            if (this.props.bid.updated) {
                this.setState({
                    editBid: true,
                    editBidMode: true
                });
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    bidCreate() {
        const defaultBidStatusId = (this.props.bids.valuesData.bidStatuses.find(status => status.name == 'Waiting Approval') || this.props.bids.valuesData.bidStatuses[0]).id;

        let emptybid = {
            accountId: 0,
            appliancePackageQuoted: false,
            bidAmount: null,
            bidNotes: [],
            bidStatusId: defaultBidStatusId,
            cabinetManufacturerId: null,
            companyName: "",
            contactName: "",
            contactPhone: null,
            estimatedStartDate: "",
            estimatedStartDateDisplay: "",
            installQuoted: false,
            kitchenTopsId: null,
            lastUpdatedAt: "",
            numberOfUnits: "0",
            projectCity: "",
            projectName: "",
            projectStateId: null,
            salesPerson: "",
            submissionDate: "",
            submissionDateDisplay: "",
            unitTypeId: null,
            vanityTopsId: null,
            bidDueDate: "",
            bidSubmittedDate: "",
            margin: null,
            quotedDoorStyle: "",
            cabinetDoorFinish: "",
            cabinetSpecified: "",
            projectOwner: ""
        };

        var today = new Date()
        var todayStr = today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()

        emptybid.submissionDateDisplay = todayStr

        this.setState({
            bid: emptybid,
            editBid: false,
            editBidMode: true
        });
    }

    bidExport() {
        window.scrollTo(0,0)
        export_excel_bids(this.props.dispatch, this.state.activeBidStatusFilters, this.state.activeStatusFilters, this.turn_off_progress_bar());
    }

    turn_off_progress_bar() {
           document.getElementById("progress_bar").display = "none";
    }

    updateBid(e) {
        $('button.modbrick').attr('disabled','disabled')

        let create = e.target.attributes.create.value;
        let bid = { bidNotes: [] };

        $('input, textarea').each(function () {
            if ($(this).attr('id') != undefined)
                bid[$(this).attr('id')]= $(this).val()

            if ($(this).attr('id') == 'installQuoted')
                bid['installQuoted'] = $(this).is(':checked')

            if ($(this).attr('id') == 'appliancePackageQuoted')
                bid['appliancePackageQuoted'] = $(this).is(':checked')
        })

        if (bid.accountId == "")
            bid.accountId = 0

        var _this = this
        $('select').each(function () {
            if (this.value != 'Select') {
                const selId = $(this).attr('id'),
                      valueId = this.value;

                bid[selId] = parseInt(valueId);
            }
        })

        if ($('textarea#newNote').val().length) {
            bid.bidNotes.push({ bidId: 0, note: $('textarea#newNote').val(), createdBy: this.props.user.userName })
        }

        if (create === 'true') {
            bid.createdby = this.props.user.userName
            createBid.bind(this)(bid)
        }
        else {
            bid.Id = this.props.bid.bid.id
            bid.LastUpdatedby = this.props.user.userName
            updateBid.bind(this)(bid.Id, bid)
        }

        chkReturn = setInterval(this.closeBid, 100);
    }

    cancelBid() {
        $('button.btn-primary').removeAttr('disabled')

        this.props.dispatch(errorBid);

        if (this.state.viewBidExtra) {
            this.setState({
                viewBid: false,
                viewBidExtra: false
            })
            window.location.pathname = '/prod-mgmt/bidslist'
        }
        else {
            this.setState({
                viewBid: false,
                editBidMode: false
            });
        }

        this.props.dispatch(fetchBidsList);
    }
    closeBid() {
        if (this.props.bid.updated || this.props.bid.error) {
            $('button.modbrick').removeAttr('disabled')

            if (this.props.bid.updated && this.state.viewBid == false) {
                this.cancelBid();
            }
            else if (this.state.viewBid)
                $('textarea#newNote').val("")

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    processStatusFilter(filters) {
        if (this.props.bids.fetching) return 

        this.setState(
            {
                clearFilter: true,
                activeStatusFilters: filters,
                activeBidStatusFilters: []
            })

        setBidsFilters.bind(this)(filters)
     }

    processBidStatusFilter(filters) {
        if (this.props.bids.fetching) return 

        this.setState({ clearFilter: false, activeBidStatusFilters: filters })
    }

    render() {
        return (
            <div className="bids col-xs-12">
                <CommError error={this.props.bid.error} onClose={this.errorBidClear} />
                <CommError error={this.props.bids.error} onClose={this.fetchBidErrorClear} />

                <ConfirmModal open={this.props.bids.noData} heading={"Bid Tracker"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div className="productBricks ">
                        <h1>Bid Tracker</h1>
                    </div>
                    <div className="button over768">
                        <button onClick={this.bidExport} className="btn btn-primary pull-right">Export</button>
                        <button onClick={this.bidCreate} className="btn btn-primary pull-right">+ Create Bid</button>
                    </div>
                    <span id="startExport">
                        {
                            this.props.bids.complete_export === false ?
                                <Spinner name='line-spin-fade-loader' />
                            :
                                null
                        }
                    </span>
                    <span id="progress_bar"><strong> Export Progress: {this.props.bids.percent_complete}%</strong>
                        <ProgressBar percentage={this.props.bids.percent_complete} />
                    </span>
                </div>

                <div className="tableWrapper"> 
                    {
                        this.props.bids.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <row>
                        <div className="col-xs-2">
                            <FilterList
                                multiselect
                                id={"Status"}
                                label={"Filter by Status"}
                                defSelections={["Active"]}
                                filters={this.props.bidsData.statusFilters}
                                processFilter={this.processStatusFilter}
                            />

                            <FilterList
                                multiselect
                                id={"BidStatus"}
                                label={"Filter by Bid Status"}
                                filters={this.props.bidsData.bidsFilters}
                                processFilter={this.processBidStatusFilter}
                                clearFilter={this.state.clearFilter}
                            />
                        </div>
                        <div className="col-xs-3">
                            <FilterList
                                multiselect
                                id={"Status"}
                                label={"Filter by Status"}
                                defSelections={["Active"]}
                                filters={this.props.bidsData.statusFilters}
                                processFilter={this.processStatusFilter}
                            />

                            <FilterList
                                multiselect
                                id={"BidStatus"}
                                label={"Filter by Bid Status"}
                                filters={this.props.bidsData.bidsFilters}
                                processFilter={this.processBidStatusFilter}
                                clearFilter={this.state.clearFilter}
                            />
                        </div>
                        <div className="col-xs-4">
                            <FilterList
                                multiselect
                                id={"Status"}
                                label={"Filter by Status"}
                                defSelections={["Active"]}
                                filters={this.props.bidsData.statusFilters}
                                processFilter={this.processStatusFilter}
                            />

                            <FilterList
                                multiselect
                                id={"BidStatus"}
                                label={"Filter by Bid Status"}
                                filters={this.props.bidsData.bidsFilters}
                                processFilter={this.processBidStatusFilter}
                                clearFilter={this.state.clearFilter}
                            />
                        </div>
                        <div className="col-xs-11">
                            <FilterList
                                multiselect
                                collapse
                                id={"Status"}
                                label={"Filter by Status"}
                                defSelections={["Active"]}
                                filters={this.props.bidsData.statusFilters}
                                processFilter={this.processStatusFilter}
                            />

                            <FilterList
                                multiselect
                                collapse
                                id={"BidStatus"}
                                label={"Filter by Bid Status"}
                                filters={this.props.bidsData.bidsFilters}
                                processFilter={this.processBidStatusFilter}
                                clearFilter={this.state.clearFilter}
                            />
                        </div>

                        <div className="under768 col-xs-11">
                            <button onClick={this.bidExport} className="btn btn-primary">Export</button>
                            <button onClick={this.bidCreate} className="btn btn-primary pull-right">+ Create Bid</button>
                        </div>

                        <div className="col-xs-8 tableWrapperCore">
                            <table className="lists table table-striped">
                                <thead>
                                    <tr className="head">
                                        <th id="SUBMIT" onClick={this.sortColumn}>Origination Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="SALES" onClick={this.sortColumn}>Sales Person<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="COMPANY" onClick={this.sortColumn}>Company<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PROJECT" onClick={this.sortColumn}>Project<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PROJECTOWNER" onClick={this.sortColumn}>Project Owner<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="MARGIN" onClick={this.sortColumn}>Margin<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="DOORSTYLE" onClick={this.sortColumn}>Door Style<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="CABINETFINISH" onClick={this.sortColumn}>Cabinet Finish<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="UNITS" onClick={this.sortColumn}>Units<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="TYPE" onClick={this.sortColumn}>Unit Type<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="STATE" onClick={this.sortColumn}>State<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="START" onClick={this.sortColumn}>Start Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="BID" onClick={this.sortColumn}>Bid Amt<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="UPDATED" onClick={this.sortColumn}>Updated At<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="STATUS" onClick={this.sortColumn}>Status<i className="fa fa-sort fa-xs"></i></th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.bids.fetched ?
                                            this.props.bidsData.bids
                                                .filter((bid) => {
                                                    if (this.state.activeStatusFilters.includes('Active') && this.props.bidsData.activeBids.hasOwnProperty(bid.bidStatusName))
                                                        return true
                                                    else if (this.state.activeStatusFilters.includes('Archive') && this.props.bidsData.archiveBids.hasOwnProperty(bid.bidStatusName))
                                                        return true
                                                    else
                                                        return false
                                                })
                                                .filter((bid) => {
                                                    if (this.state.activeBidStatusFilters.length == 0)
                                                        return true
                                                    else if (this.state.activeBidStatusFilters.includes(bid.bidStatusName))
                                                        return true
                                                    else
                                                        return false
                                                })
                                                .map((bid, index) => {
                                                    return <tr className="body" key={index}>
                                                        <td>{bid.submissionDateDisplay}</td>
                                                        <td className="name" bid={bid.id} biddate={bid.submissionDateDisplay} onClick={this.bidView}>{bid.salesPerson}</td>
                                                        <td>{bid.companyName}</td>
                                                        <td>{bid.projectName}</td>
                                                        <td>{bid.projectOwner}</td>
                                                        <td>{bid.margin}</td>
                                                        <td>{bid.quotedDoorStyle}</td>
                                                        <td>{bid.cabinetDoorFinish}</td>
                                                        <td>{bid.numberOfUnits}</td>
                                                        <td>{bid.unitTypeName}</td>
                                                        <td>{bid.projectStateName}</td>
                                                        <td>{bid.estimatedStartDateDisplay}</td>
                                                        <td>{bid.bidAmount.toLocaleString("en-US", {style: "currency", currency: "USD"})}</td>
                                                        <td>{bid.lastUpdatedAtDisplay}</td>
                                                        <td>{bid.bidStatusName}</td>
                                                        <td>
                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                                <i className="fa fa-edit" bid={bid.id} onClick={this.bidEdit}></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                })
                                            : null
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="col-xs-9 tableWrapperCore">
                            <table className="lists table table-striped">
                                <thead>
                                    <tr className="head">
                                        <th id="SUBMIT" onClick={this.sortColumn}>Origination Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="SALES" onClick={this.sortColumn}>Sales Person<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="COMPANY" onClick={this.sortColumn}>Company<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PROJECT" onClick={this.sortColumn}>Project<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PROJECTOWNER" onClick={this.sortColumn}>Project Owner<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="MARGIN" onClick={this.sortColumn}>Margin<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="DOORSTYLE" onClick={this.sortColumn}>Door Style<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="CABINETFINISH" onClick={this.sortColumn}>Cabinet Finish<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="UNITS" onClick={this.sortColumn}>Units<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="TYPE" onClick={this.sortColumn}>Unit Type<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="STATE" onClick={this.sortColumn}>State<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="START" onClick={this.sortColumn}>Start Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="BID" onClick={this.sortColumn}>Bid Amt<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="UPDATED" onClick={this.sortColumn}>Updated At<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="STATUS" onClick={this.sortColumn}>Status<i className="fa fa-sort fa-xs"></i></th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.bids.fetched ?
                                            this.props.bidsData.bids
                                                .filter((bid) => {
                                                    if (this.state.activeStatusFilters.includes('Active') && this.props.bidsData.activeBids.hasOwnProperty(bid.bidStatusName))
                                                        return true
                                                    else if (this.state.activeStatusFilters.includes('Archive') && this.props.bidsData.archiveBids.hasOwnProperty(bid.bidStatusName))
                                                        return true
                                                    else
                                                        return false
                                                })
                                                .filter((bid) => {
                                                    if (this.state.activeBidStatusFilters.length == 0)
                                                        return true
                                                    else if (this.state.activeBidStatusFilters.includes(bid.bidStatusName))
                                                        return true
                                                    else
                                                        return false
                                                })
                                                .map((bid, index) => {
                                                    return <tr className="body" key={index}>
                                                        <td>{bid.submissionDateDisplay}</td>
                                                        <td className="name" bid={bid.id} biddate={bid.submissionDateDisplay} onClick={this.bidView}>{bid.salesPerson}</td>
                                                        <td>{bid.companyName}</td>
                                                        <td>{bid.projectName}</td>
                                                        <td>{bid.projectOwner}</td>
                                                        <td>{bid.margin}</td>
                                                        <td>{bid.quotedDoorStyle}</td>
                                                        <td>{bid.cabinetDoorFinish}</td>
                                                        <td>{bid.numberOfUnits}</td>
                                                        <td>{bid.unitTypeName}</td>
                                                        <td>{bid.projectStateName}</td>
                                                        <td>{bid.estimatedStartDateDisplay}</td>
                                                        <td>{bid.bidAmount}</td>
                                                        <td>{bid.lastUpdatedAtDisplay}</td>
                                                        <td>{bid.bidStatusName}</td>
                                                        <td>
                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                                <i className="fa fa-edit" bid={bid.id} onClick={this.bidEdit}></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                })
                                        : null
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="col-xs-10 tableWrapperCore">
                            <table className="lists table table-striped">
                                <thead>
                                    <tr className="head">
                                        <th id="SUBMIT" onClick={this.sortColumn}>Origination Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="SALES" onClick={this.sortColumn}>Sales Person<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="COMPANY" onClick={this.sortColumn}>Company<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PROJECT" onClick={this.sortColumn}>Project<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PROJECTOWNER" onClick={this.sortColumn}>Project Owner<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="MARGIN" onClick={this.sortColumn}>Margin<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="DOORSTYLE" onClick={this.sortColumn}>Door Style<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="CABINETFINISH" onClick={this.sortColumn}>Cabinet Finish<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="UNITS" onClick={this.sortColumn}>Units<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="TYPE" onClick={this.sortColumn}>Unit Type<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="STATE" onClick={this.sortColumn}>State<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="START" onClick={this.sortColumn}>Start Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="BID" onClick={this.sortColumn}>Bid Amt<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="UPDATED" onClick={this.sortColumn}>Updated At<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="STATUS" onClick={this.sortColumn}>Status<i className="fa fa-sort fa-xs"></i></th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.bids.fetched ?
                                            this.props.bidsData.bids
                                                .filter((bid) => {
                                                    if (this.state.activeStatusFilters.includes('Active') && this.props.bidsData.activeBids.hasOwnProperty(bid.bidStatusName))
                                                        return true
                                                    else if (this.state.activeStatusFilters.includes('Archive') && this.props.bidsData.archiveBids.hasOwnProperty(bid.bidStatusName))
                                                        return true
                                                    else
                                                        return false
                                                })
                                                .filter((bid) => {
                                                    if (this.state.activeBidStatusFilters.length == 0)
                                                        return true
                                                    else if (this.state.activeBidStatusFilters.includes(bid.bidStatusName))
                                                        return true
                                                    else
                                                        return false
                                                })
                                                .map((bid, index) => {
                                                    return <tr className="body" key={index}>
                                                        <td>{bid.submissionDateDisplay}</td>
                                                        <td className="name" bid={bid.id} biddate={bid.submissionDateDisplay} onClick={this.bidView}>{bid.salesPerson}</td>
                                                        <td>{bid.companyName}</td>
                                                        <td>{bid.projectName}</td>
                                                        <td>{bid.projectOwner}</td>
                                                        <td>{bid.margin}</td>
                                                        <td>{bid.quotedDoorStyle}</td>
                                                        <td>{bid.cabinetDoorFinish}</td>
                                                        <td className="rightdata">{bid.numDispUnits}</td>
                                                        <td>{bid.unitTypeName}</td>
                                                        <td>{bid.projectStateName}</td>
                                                        <td>{bid.estimatedStartDateDisplay}</td>
                                                        <td className="rightdata">{bid.bidAmount.toLocaleString("en-US", { style: "currency", currency: "USD" })}</td>
                                                        <td>{bid.lastUpdatedAtDisplay}</td>
                                                        <td>{bid.bidStatusName}</td>
                                                        <td>
                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                                <i className="fa fa-edit" bid={bid.id} onClick={this.bidEdit}></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                })
                                            : null
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="col-xs-11 tableWrapperCore">
                            <table className="lists table table-striped">
                                <thead>
                                    <tr className="head">
                                        <th id="SUBMIT" onClick={this.sortColumn}>Origination Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="SALES" onClick={this.sortColumn}>Sales Person<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="COMPANY" onClick={this.sortColumn}>Company<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PROJECT" onClick={this.sortColumn}>Project<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PROJECTOWNER" onClick={this.sortColumn}>Project Owner<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="MARGIN" onClick={this.sortColumn}>Margin<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="DOORSTYLE" onClick={this.sortColumn}>Door Style<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="CABINETFINISH" onClick={this.sortColumn}>Cabinet Finish<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="UNITS" onClick={this.sortColumn}>Units<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="TYPE" onClick={this.sortColumn}>Unit Type<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="STATE" onClick={this.sortColumn}>State<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="START" onClick={this.sortColumn}>Start Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="BID" onClick={this.sortColumn}>Bid Amt<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="UPDATED" onClick={this.sortColumn}>Updated At<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="STATUS" onClick={this.sortColumn}>Status<i className="fa fa-sort fa-xs"></i></th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.bids.fetched ?
                                            this.props.bidsData.bids
                                                .filter((bid) => {
                                                    if (this.state.activeStatusFilters.includes('Active') && this.props.bidsData.activeBids.hasOwnProperty(bid.bidStatusName))
                                                        return true
                                                    else if (this.state.activeStatusFilters.includes('Archive') && this.props.bidsData.archiveBids.hasOwnProperty(bid.bidStatusName))
                                                        return true
                                                    else
                                                        return false
                                                })
                                                .filter((bid) => {
                                                    if (this.state.activeBidStatusFilters.length == 0)
                                                        return true
                                                    else if (this.state.activeBidStatusFilters.includes(bid.bidStatusName))
                                                        return true
                                                    else
                                                        return false
                                                })
                                                .map((bid, index) => {
                                                    return <tr className="body" key={index}>
                                                        <td>{bid.submissionDateDisplay}</td>
                                                        <td className="name" bid={bid.id} biddate={bid.submissionDateDisplay} onClick={this.bidView}>{bid.salesPerson}</td>
                                                        <td>{bid.companyName}</td>
                                                        <td>{bid.projectName}</td>
                                                        <td>{bid.projectOwner}</td>
                                                        <td>{bid.margin}</td>
                                                        <td>{bid.quotedDoorStyle}</td>
                                                        <td>{bid.cabinetDoorFinish}</td>
                                                        <td>{bid.numberOfUnits}</td>
                                                        <td>{bid.unitTypeName}</td>
                                                        <td>{bid.projectStateName}</td>
                                                        <td>{bid.estimatedStartDateDisplay}</td>
                                                        <td>{bid.bidAmount}</td>
                                                        <td>{bid.lastUpdatedAtDisplay}</td>
                                                        <td>{bid.bidStatusName}</td>
                                                        <td>
                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                                <i className="fa fa-edit" bid={bid.id} onClick={this.bidEdit}></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                })
                                            : null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </row>

                    <div className="button over768">
                        <button onClick={this.bidExport}className="btn btn-primary pull-right">Export</button>
                        <button onClick={this.bidCreate} className="btn btn-primary pull-right">+ Create Bid</button>
                    </div>
                </div>

                <CreateEditBid
                    errBid={this.props.bid}
                    errBidClear={this.errorBidClear}

                    curBid={this.props.bid}
                    tmpBid={this.state.bid}
                    histPage={this.state.historyPage}

                    isCreate={!this.state.editBid}
                    isOpen={this.state.editBidMode}
                    bidCheck={this.bidCheck}
                    viewOnly={this.state.viewBid}
                    selectPanel={this.selectPanel}
                    users={this.props.bid.users}
                    newDateSearch={this.newDateSearch}
                    newUserSearch={this.newUserSearch}
                    loadMore={this.loadMore}

                    onAfterOpen={this.afterOpen}
                    onRequestClose={this.updateBid}
                    onRequestCancel={this.cancelBid}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    bid: state.bid,
    bids: state.bids,
    user: state.userManager.userInfo
});

export default connect(mapStateToProps)(Bids)